import { useEffect, useState } from "react";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AllQCReview from "./all-qc-review";
import UnAssignedQCReview from "./unassigned-qc-review";
import AssignedQCReview from "./assigned-qc-review";
import FinalQCReview from "./final-qc-review";
import eventBus from "../../../utils/EventBus";
import Notification from "../../../components/notification/notification";
import ContactSpectrum from "../../../components/contact-spectrum/constact-spectrum";
import { userType } from "../../../utils/Constant";
import { useSelector } from "react-redux";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function TabLabel(data: any) {
  return (
    <>
      {data?.label}
      {data?.showWarning && (
        <InfoOutlinedIcon className="tab-label-warning-icon" />
      )}
    </>
  );
}

export default function OrderQCReview() {
  const [value, setValue] = useState(0);
  const [showSuccessNotification, setShowSuccessNotification] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const { currentUser } = useSelector((state: any) => state.user.user);

  useEffect(() => {
    eventBus.addListener("createIssuesSuccess", onCreateIssuesSuccess);
    return () => {
      eventBus.removeListener("createIssuesSuccess", onCreateIssuesSuccess);
    };
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const onCreateIssuesSuccess = () => {
    setSuccessMessage("Created Issues Successfully.");
    setShowSuccessNotification(true);
  };

  return (
    <>
      {currentUser?.userType !== userType.client && <ContactSpectrum />}
      <Box mt={currentUser?.userType === userType.client ? 2 : 0}>
        <Breadcrumb />
      </Box>
      <Typography sx={{ ml: 2, mt: 1 }} variant="h4">
        QC Review
      </Typography>
      <Box
        sx={{ mt: 3, mx: 2 }}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="orders tabs"
          variant="scrollable"
          scrollButtons={false}
        >
          <Tab
            className="tab-label"
            label={<TabLabel label="All" showWarning={false} />}
          />
          <Tab
            className="tab-label"
            label={<TabLabel label="Unassigned QC" showWarning={false} />}
          />
          <Tab
            className="tab-label"
            label={<TabLabel label="Assigned QC" showWarning={false} />}
          />
          <Tab
            className="tab-label"
            label={<TabLabel label="Final QC" showWarning={false} />}
          />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <AllQCReview />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <UnAssignedQCReview />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <AssignedQCReview />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <FinalQCReview />
      </CustomTabPanel>
      {showSuccessNotification && (
        <Notification
          show={showSuccessNotification}
          message={successMessage}
          onClose={() => setShowSuccessNotification(false)}
        />
      )}
    </>
  );
}
